module.exports = __webpack_public_path__ + "img/grid-dots-blank.1c1de161.svg";